import { PillButton } from "./SitePrimitives";

export function SiteCta({
  title,
  ctaLabel,
  ctaHref,
  onCta,
}: {
  title: string;
  ctaLabel: string;
  ctaHref: string;
  onCta: () => void;
}) {
  if (!title && !ctaLabel) return null;
  return (
    <section data-site-section="cta" className="pt-6 min-[810px]:pt-[41px] min-[1200px]:pt-16">
      <div className="site-container">
        <div className="flex flex-col items-center justify-center gap-[21px] rounded-xl bg-[#0F2827] px-6 pb-[31px] pt-6 text-center min-[810px]:flex-row min-[810px]:justify-between min-[810px]:px-10 min-[810px]:py-10 min-[1200px]:justify-center min-[1200px]:gap-16">
          {title ? <p className="site-h3 text-white min-[810px]:max-w-[478px] min-[810px]:text-left min-[1200px]:max-w-none">{title}</p> : null}
          {ctaLabel ? (
            <PillButton
              href={ctaHref}
              arrow
              onClick={onCta}
              className="max-[809px]:rounded-[10px] max-[809px]:px-3 max-[809px]:py-2 max-[809px]:text-[14px]"
            >
              {ctaLabel}
            </PillButton>
          ) : null}
        </div>
      </div>
    </section>
  );
}
